import React from 'react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = (page: number) => {
    onPageChange(page);
  };

    // Generate page numbers
    const getPaginationItems = () => {
      const items: JSX.Element[] = [];
      const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  
      const visiblePages = 5; // Number of visible page links
  
      if (totalPages <= visiblePages) {
        return pageNumbers.map(number => (
          <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
            <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); handlePageChange(number); }}>
              {number}
            </a>
          </li>
        ));
      } else {
        if (currentPage <= 3) {
          for (let i = 1; i <= Math.min(visiblePages, totalPages); i++) {
            items.push(
              <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); handlePageChange(i); }}>
                  {i}
                </a>
              </li>
            );
          }
          items.push(<li key="ellipsis1" className="page-item disabled"><span className="page-link">...</span></li>);
          items.push(
            <li key={totalPages} className={`page-item ${currentPage === totalPages ? 'active' : ''}`}>
              <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); handlePageChange(totalPages); }}>
                {totalPages}
              </a>
            </li>
          );
        } else if (currentPage >= totalPages - 2) {
          items.push(
            <li key={1} className={`page-item ${currentPage === 1 ? 'active' : ''}`}>
              <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); handlePageChange(1); }}>
                1
              </a>
            </li>
          );
          items.push(<li key="ellipsis1" className="page-item disabled"><span className="page-link">...</span></li>);
          for (let i = totalPages - visiblePages + 1; i <= totalPages; i++) {
            items.push(
              <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); handlePageChange(i); }}>
                  {i}
                </a>
              </li>
            );
          }
        } else {
          items.push(
            <li key={1} className={`page-item ${currentPage === 1 ? 'active' : ''}`}>
              <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); handlePageChange(1); }}>
                1
              </a>
            </li>
          );
          items.push(<li key="ellipsis1" className="page-item disabled"><span className="page-link">...</span></li>);
          for (let i = currentPage - 1; i <= currentPage + 1; i++) {
            items.push(
              <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); handlePageChange(i); }}>
                  {i}
                </a>
              </li>
            );
          }
          items.push(<li key="ellipsis2" className="page-item disabled"><span className="page-link">...</span></li>);
          items.push(
            <li key={totalPages} className={`page-item ${currentPage === totalPages ? 'active' : ''}`}>
              <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); handlePageChange(totalPages); }}>
                {totalPages}
              </a>
            </li>
          );
        }
  
        return items;
      }
    };

  return (
    <div className="row mt-5">
    <div className="col-12 d-flex justify-content-center">
      <nav aria-label="Page navigation">
        <ul className="pagination">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <a
              className="page-link"
              href="#"
              onClick={(e) => { e.preventDefault(); handlePageChange(currentPage - 1); }}
              aria-disabled={currentPage === 1}
            >
              Προηγούμενη
            </a>
          </li>
          {getPaginationItems()}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <a
              className="page-link"
              href="#"
              onClick={(e) => { e.preventDefault(); handlePageChange(currentPage + 1); }}
              aria-disabled={currentPage === totalPages}
            >
              Επόμενη
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
  );
};

export default Pagination;
